import { intfc_prefix_common } from 'constants/project'
let initWxShare = function ({title,imgUrl,desc}, that) {
    let url = encodeURIComponent(window.location.href.split('#')[0]);
    let newImgUrl = null
    that.$axios.get(intfc_prefix_common + '/api/v2/wechat/getWechatInfo?url=' + url)
        .then(res => {
            let result = res.item;
            console.log('getWechatInfo:', result);
            console.log(title,imgUrl,desc);
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: result.appId, // 必填，公众号的唯一标识
                timestamp: result.timestamp, // 必填，生成签名的时间戳
                nonceStr: result.nonceStr, // 必填，生成签名的随机串
                signature: result.signature,// 必填，签名，见附录1
                jsApiList: [
                    "onMenuShareTimeline","onMenuShareAppMessage","onMenuShareQQ","onMenuShareQZone","onMenuShareWeibo"
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            that.$axios.get(intfc_prefix_common + '/api/client/backGround/getImageInfo').then(res=>{
                if(res.item && res.item.weiChat && res.item.weiChat.backGroundUrl){
                    newImgUrl = res.item.weiChat.backGroundUrl
                }
            })
            //console.log('newImgUrl',newImgUrl)
            wx.ready(function () {
                const shareData = {
                    link: window.location.href,
                    title,
                    desc: desc?desc:'天下景观在锦观',
                    imgUrl: newImgUrl?newImgUrl:'https://rmrbpre.oss-cn-beijing.aliyuncs.com/cdrb-prod/dir2/logo.png'   //'http://rmrbpre.img-cn-beijing.aliyuncs.com/cdrb2/dir2/20190513/cdrb_2_201503133341dc-40bd-4efb-85f2-ae81b3c86ccc.png'
                };
                // alert("f1_"+window.location.href)
                wx.onMenuShareTimeline(shareData);
                wx.onMenuShareAppMessage(shareData);
                wx.onMenuShareQQ(shareData);
                wx.onMenuShareWeibo(shareData);
                wx.onMenuShareQZone(shareData);
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            });
            wx.error(function (res) {
                console.log(res)
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
        })
        .catch(err => {
            console.log(err);
        })
}

export default initWxShare;



// WEBPACK FOOTER //
// ./src/services/weChatShare.js